export const FOTOS_2025 = [
    {
        "src": "gallery/2025/intercorr2025_001.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_002.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_003.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_004.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_005.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_006.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_007.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_008.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_009.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_010.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_011.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_012.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_013.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_014.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_015.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_016.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_017.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_018.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_019.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_020.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_021.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_022.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_023.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_024.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_025.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_026.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_027.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_028.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_029.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_030.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_031.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_032.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_033.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_034.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_035.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_036.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_037.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_038.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_039.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_040.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_041.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_042.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_043.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_044.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_045.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_046.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_047.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_048.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_049.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_050.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_051.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_052.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_053.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_054.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_055.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_056.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_057.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_058.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_059.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_060.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_061.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_062.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_063.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_064.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_065.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_066.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_067.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_068.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_069.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_070.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_071.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_072.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_073.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_074.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_075.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_076.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_077.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_078.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_079.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_080.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_081.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_082.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_083.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_084.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_085.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_086.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_087.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_088.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_089.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_090.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_091.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_092.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_093.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_094.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_095.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_096.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_097.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_098.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_099.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_100.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_101.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_102.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_103.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_104.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_105.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_106.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_107.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_108.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_109.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_110.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_111.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_112.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_113.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_114.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_115.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_116.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_117.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_118.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_119.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_120.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_121.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_122.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_123.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_124.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_125.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_126.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_127.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_128.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_129.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_130.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_131.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_132.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_133.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_134.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_135.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_136.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_137.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_138.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_139.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_140.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_141.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_142.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_143.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_144.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_145.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_146.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_147.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_148.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_149.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_150.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_151.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_152.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_153.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_154.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_155.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_156.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_157.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_158.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_159.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_160.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_161.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_162.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_163.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_164.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_165.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_166.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_167.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_168.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_169.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_170.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_171.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_172.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_173.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_174.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_175.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_176.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_177.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_178.jpg",
        "width": 1200,
        "height": 801
    },
    {
        "src": "gallery/2025/intercorr2025_179.jpg",
        "width": 1200,
        "height": 801
    }
]
